import { gql } from '@apollo/client';

const GET_KEYBOARDING_MODULES = gql`
  query keyboardingModules($where: KeyboardingModulesWhereInput!) {
    keyboardingModules(where: $where) {
      id
      name
      description
      productCurriculumId
      productCurriculum {
        id
        name
        code
      }
      thumbnailId
      thumbnail {
        id
        src
      }
      submodules {
        id
        name
        description
        productCurriculumId
        productCurriculum {
          id
          name
          code
        }
        thumbnailId
        thumbnail {
          id
          src
        }
        activities {
          id
          name
          title
          description
          category
          url
        }
      }
    }
  }
`;

export default GET_KEYBOARDING_MODULES;
